import { render, staticRenderFns } from "./printQuestionnaire.vue?vue&type=template&id=1270070e"
import script from "./printQuestionnaire.vue?vue&type=script&lang=js"
export * from "./printQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports